<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header pb-0">
            <h4>Reporte de productos Super Kompras va</h4>
            <span class="text-muted small ms-2">
              Mostrando {{ items.length }} de {{ filtrados.length }} registros.
            </span>
          </div>
          <div class="card-body">
            <div class="search-filters mb-4">
              <div class="row g-3 align-items-end mb-3">
                <div class="col-md-6 col-lg-4">
                  <label class="form-label small fw-semibold">Con Fotografía:</label>
                  <select v-model="filters.foto" class="form-select">
                    <option value="TODAS">Ambas</option>
                    <option value="SI">Sí</option>
                    <option value="NO">No</option>
                  </select>
                </div>
                <div class="col-md-6 col-lg-4">
                  <label class="form-label small fw-semibold">Filtrado Por Producto:</label>
                  <input v-model.trim="filters.busqueda" type="text" class="form-control"
                    placeholder="Código de barras o descripción" @keyup.enter="consultar" />
                </div>
                <div class="col-md-12 col-lg-4">
                  <button type="button"
                    class="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
                    :disabled="loading" @click="consultar">
                    <vue-feather type="search" size="16" />
                    Consultar
                  </button>
                </div>
              </div>
              <div class="row g-3 align-items-end">
                <div class="col-md-12 col-lg-4 offset-lg-8">
                  <button type="button"
                    class="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
                    :disabled="loading || !filtrados.length" @click="descargarInforme">
                    <vue-feather type="download" size="16" />
                    Exportar resultados
                  </button>
                </div>
              </div>
            </div>

            <div class="row">
              <div v-if="!items.length && !loading" class="col-12 text-center py-5 text-muted">
                No hay registros para mostrar.
              </div>
              <div v-else class="order-history table-responsive theme-scrollbar wishlist col-12">
                <table class="table display dataTable table-bordered mb-0">
                  <thead>
                    <tr>
                      <th>Código de Barras</th>
                      <th>Descripción</th>
                      <th>NProv</th>
                      <th>RFC</th>
                      <th>SCategoría</th>
                      <th>Categoría</th>
                      <th>SBCategoría</th>
                      <th>Grupo</th>
                      <th>Foto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loading">
                      <td colspan="9" class="text-center py-4">Cargando productos...</td>
                    </tr>
                    <template v-else>
                      <tr v-for="(row, i) in items" :key="`${row.cb}-${i}`" class="odd">
                        <td class="sorting_1">
                          <div class="product-name">
                            <h6 class="mb-0">{{ row.cb }}</h6>
                          </div>
                        </td>
                        <td class="sorting_1">{{ row.descripcion || "—" }}</td>
                        <td class="sorting_1">{{ row.nprov || "—" }}</td>
                        <td class="sorting_1">{{ row.rfc || "—" }}</td>
                        <td class="sorting_1">{{ row.scategoria || "—" }}</td>
                        <td class="sorting_1">{{ row.categoria || "—" }}</td>
                        <td class="sorting_1">{{ row.sbcategoria || "—" }}</td>
                        <td class="sorting_1">{{ row.grupo || "—" }}</td>
                        <td class="sorting_1">
                          <span :class="fotoBadge(row)">{{ fotoTexto(row) }}</span>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>

            <PaginacionTabla :pagina="pagina" :total-paginas="totalPaginas"
              :deshabilitado="loading" @cambiar="pagina = $event" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginacionTabla from "@/components/PaginacionTabla.vue";
import { apiFetch, BASE_URL } from "@/services/api";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import * as XLSX from "xlsx";

const FILTROS_FOTO = ["TODAS", "SI", "NO"];

export default {
  name: "ProductosApp",
  components: { PaginacionTabla },
  data() {
    const foto = String(this.$route.query.foto || "").toUpperCase();
    return {
      // Lista completa de Hasura; la búsqueda y el paginado se hacen aquí.
      productos: [],
      fotoConsultada: "TODAS",
      busquedaAplicada: "",
      loading: false,
      filters: {
        foto: FILTROS_FOTO.includes(foto) ? foto : "TODAS",
        busqueda: "",
      },
      pagina: 1,
      porPagina: 10,
    };
  },
  computed: {
    filtrados() {
      const q = this.busquedaAplicada.toLowerCase();
      if (!q) return this.productos;
      return this.productos.filter(
        (p) =>
          String(p.cb ?? "").toLowerCase().includes(q) ||
          String(p.descripcion ?? "").toLowerCase().includes(q)
      );
    },
    totalPaginas() {
      return Math.ceil(this.filtrados.length / this.porPagina) || 1;
    },
    items() {
      const inicio = (this.pagina - 1) * this.porPagina;
      return this.filtrados.slice(inicio, inicio + this.porPagina);
    },
  },
  created() {
    this.cargarProductos();
  },
  methods: {
    consultar() {
      if (this.$route.query.foto !== this.filters.foto) {
        this.$router.replace({ query: { ...this.$route.query, foto: this.filters.foto } });
      }
      this.cargarProductos(true);
    },
    async cargarProductos(showSuccessModal = false) {
      const foto = this.filters.foto;
      const url =
        foto === "TODAS"
          ? `${BASE_URL}/api/dashboard/app/productos`
          : `${BASE_URL}/api/dashboard/app/productos/foto/${foto}`;

      this.loading = true;
      try {
        const response = await apiFetch(url);
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.message || `Error HTTP ${response.status}`);

        this.productos = data.data || [];
        this.fotoConsultada = foto;
        this.busquedaAplicada = this.filters.busqueda;
        this.pagina = 1;

        if (showSuccessModal) {
          const total = this.filtrados.length;
          Swal.fire({
            title: "Consulta Exitosa",
            html: `<div class="mb-3"><p>Se han encontrado ${total} producto${total !== 1 ? "s" : ""}.</p></div>`,
            icon: "success",
            confirmButtonText: "Aceptar",
          });
        }
      } catch (error) {
        console.error("Error al obtener productos de la APP:", error);
        this.productos = [];
        Swal.fire({
          title: "Error en la Consulta",
          text: error.message || "No se pudieron cargar los productos. Por favor, intenta nuevamente.",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      } finally {
        this.loading = false;
      }
    },
    valorFoto(row) {
      return String(row.FOTO ?? row.foto ?? "").toUpperCase();
    },
    fotoTexto(row) {
      const foto = this.valorFoto(row);
      if (foto === "SI") return "Sí";
      if (foto === "NO") return "No";
      return foto || "—";
    },
    fotoBadge(row) {
      return this.valorFoto(row) === "SI"
        ? "badge bg-success-subtle text-success"
        : "badge bg-light text-muted";
    },
    descargarInforme() {
      const headers = ["Cb", "Descripcion", "NProv", "RFC", "SCategoria", "Categoria", "SBCategoria", "Grupo", "Foto"];
      const data = [
        headers,
        ...this.filtrados.map((r) => [
          r.cb,
          r.descripcion ?? "",
          r.nprov ?? "",
          r.rfc ?? "",
          r.scategoria ?? "",
          r.categoria ?? "",
          r.sbcategoria ?? "",
          r.grupo ?? "",
          this.valorFoto(r),
        ]),
      ];
      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "REPORTE_PRODUCTOS");
      const d = new Date();
      const fecha = `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
      const sufijo = { TODAS: "todos", SI: "con foto", NO: "sin foto" }[this.fotoConsultada];
      XLSX.writeFile(wb, `Reporte productos Super Kompras ${sufijo} ${fecha}.xlsx`);
    },
  },
};
</script>
